import { render, staticRenderFns } from "./ProcesoViewDetalle.vue?vue&type=template&id=e2b537e8&scoped=true"
import script from "./ProcesoViewDetalle.vue?vue&type=script&lang=js"
export * from "./ProcesoViewDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b537e8",
  null
  
)

export default component.exports